
import { useState, useEffect } from 'react';

interface HalachicDateData {
  hebrewDate: string;
  gregorianDate: string;
  isAfterSunset: boolean;
}

export const useHalachicDate = (): HalachicDateData => {
  const [dateData, setDateData] = useState<HalachicDateData>({
    hebrewDate: '',
    gregorianDate: '',
    isAfterSunset: false
  });

  useEffect(() => {
    const updateDate = () => {
      const now = new Date();
      const israelTime = new Date(now.toLocaleString("en-US", {timeZone: "Asia/Jerusalem"}));
      
      // Simple sunset approximation (can be enhanced with actual sunset calculation)
      const isAfterSunset = israelTime.getHours() >= 19; // 7 PM approximation
      
      // For display purposes, we'll use simple date formatting
      const gregorianDate = israelTime.toLocaleDateString('he-IL', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      // Placeholder Hebrew date - in production, use actual Hebrew calendar library
      const hebrewDate = "כ״ה אייר תשפ״ה"; // This should come from actual calculation

      setDateData({
        hebrewDate,
        gregorianDate,
        isAfterSunset
      });
    };

    updateDate();
    const interval = setInterval(updateDate, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  return dateData;
};
